<template>
  <div id="lom-award-preview" class="professional-preview-dialog">
    <v-card class="main-preview-container" elevation="8">
      <!-- Professional Header -->
      <div class="professional-app-bar">
        <div class="app-bar-background">
          <div class="background-pattern"></div>
          <div class="background-overlay"></div>
        </div>
        <div class="app-bar-content">
          <div class="left-section">
            <span class="title-content animate-title">
              <v-icon color="#1976d2" size="32" class="mr-2 animate-icon"
                >mdi-trophy-award</v-icon
              >
              <span class="main-title">{{ PageTitle }}</span>
            </span>
          </div>
          <div class="right-section">
            <v-btn
              icon
              color="#1976d2"
              @click="closePrompt"
              class="professional-close-btn"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
      <!-- Professional Loading State -->
      <div class="professional-loading-section" v-if="LoadingFlag">
        <div class="loading-container">
          <v-progress-circular
            indeterminate
            color="#1976d2"
          ></v-progress-circular>
          <p class="loading-text mt-4">Loading award details...</p>
        </div>
      </div>
      <!-- Main Content -->
      <v-card-text
        class="main-content-wrapper"
        v-if="row != '' && !LoadingFlag"
      >
        <v-container class="py-0">
          <!-- Award Status Section -->
          <div class="award-section-card mb-4">
            <div class="section-header">
              <span class="section-title-wrapper">
                <v-icon color="#1976d2" class="mr-2">mdi-check-decagram</v-icon>
                <span class="section-title">Award Details</span>
              </span>
            </div>
            <div class="section-content">
              <v-row wrap>
                <v-col cols="12" sm="6" md="4">
                  <div class="detail-item">
                    <span class="detail-label">Award Status</span>
                    <span class="detail-value">
                      <v-chip
                        :color="row.AwardStatusColor"
                        class="status-chip"
                        dark
                      >
                        {{ row.AwardStatusTxt }}
                      </v-chip>
                    </span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="detail-item">
                    <span class="detail-label">Award Register No</span>
                    <span class="detail-value">{{
                      row.AwardRegisterNumber
                    }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="detail-item">
                    <span class="detail-label">Award Type</span>
                    <span class="detail-value">{{
                      row.AwardTypeTitleTxt
                    }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="detail-item">
                    <span class="detail-label">LO Name</span>
                    <span class="detail-value">{{ row.LomName }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="detail-item">
                    <span class="detail-label">Zone Name</span>
                    <span class="detail-value">{{ row.ZoneDisplayText }}</span>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <!-- Member Information Section -->
          <div class="award-section-card mb-4">
            <div class="section-header">
              <span class="section-title-wrapper">
                <v-icon color="#1976d2" class="mr-2">mdi-account-tie</v-icon>
                <span class="section-title">Nominee Details</span>
              </span>
            </div>
            <div class="section-content">
              <v-row wrap>
                <v-col cols="12" class="member-photo-section">
                  <div class="photo-container">
                    <viewer rebuild :images="row.MemberImageArray">
                      <img
                        class="member-avatar"
                        style="width: 100px; height: 100px"
                        :src="src"
                        :key="src"
                        v-for="src in row.MemberImageArray"
                      />
                    </viewer>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="detail-item">
                    <span class="detail-label">Membership Id</span>
                    <span class="detail-value">{{ row.MembershipId }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="detail-item">
                    <span class="detail-label">Member Name</span>
                    <span class="detail-value">{{ row.MemberFullName }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="detail-item">
                    <span class="detail-label">Email Id</span>
                    <span class="detail-value">{{ row.EmailId }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="detail-item">
                    <span class="detail-label">Mobile No</span>
                    <span class="detail-value">{{ row.MobileNo }}</span>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <!-- Score card -->
          <div
            class="award-section-card mb-4 score-details-section animate-fade-in"
          >
            <div class="section-header">
              <span class="section-title-wrapper">
                <v-icon color="#7c4dff" class="mr-2">mdi-star-check</v-icon>
                <span class="section-title">JCI Points Summary</span>
              </span>
            </div>
            <div class="section-content">
              <template
                v-if="
                  row.AwardJciPointsData &&
                  Array.isArray(row.AwardJciPointsData) &&
                  row.AwardJciPointsData.length
                "
              >
                <v-simple-table class="award-jci-table responsive-table">
                  <thead>
                    <tr>
                      <th class="text-center">Criteria</th>
                      <th class="text-center">Max Points</th>
                      <th class="text-center">Received Points</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in row.AwardJciPointsData"
                      :key="index"
                      class="score-row"
                    >
                      <td class="criteria-cell">
                        <span class="criteria-text">{{ item.Criteria }}</span>
                      </td>
                      <td class="max-points-cell">{{ item.MaxPoints }}</td>
                      <td>
                        <v-chip
                          class="score-chip animate-chip"
                          :style="{
                            backgroundColor: item.PointsColor
                              ? item.PointsColor
                              : '#7c4dff',
                            color: '#000',
                            fontSize: '16px',
                            minWidth: '48px',
                            justifyContent: 'center',
                          }"
                          large
                          outlined
                        >
                          {{ item.ReceivedPoints }}
                        </v-chip>
                      </td>
                    </tr>
                    <!-- Total row -->
                    <tr class="score-total-row">
                      <td class="font-weight-bold text-left" colspan="2">
                        Total
                      </td>
                      <td class="font-weight-bold">
                        {{
                          row.AwardJciPointsData.reduce(
                            (sum, item) =>
                              sum + Number(item.ReceivedPoints || 0),
                            0
                          )
                        }}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </template>
              <template v-else>
                <div class="no-score-data text-center py-5">
                  <v-icon color="#bdbdbd" size="48"
                    >mdi-alert-circle-outline</v-icon
                  >
                  <h4 class="grey--text mt-2 mb-1">
                    No JCI Points data available.
                  </h4>
                  <p class="grey--text">
                    JCI Points Summary will appear here when data is available.
                  </p>
                </div>
              </template>
            </div>
          </div>

          <!-- Judging Criteria Section -->
          <div class="award-section-card">
            <div class="section-header">
              <span class="section-title-wrapper">
                <v-icon color="#1976d2" class="mr-2"
                  >mdi-clipboard-check-outline</v-icon
                >
                <span class="section-title">Judging Criteria Details</span>
              </span>
            </div>
            <div class="section-content">
              <v-row
                wrap
                v-for="item in row.AwardAnswersArray"
                :key="item.SNo"
                class="criteria-item-wrapper"
              >
                <v-col cols="12">
                  <div
                    class="criteria-title-section"
                    v-if="item.CriteriaTitleFlag"
                  >
                    <div class="criteria-title-card">
                      <div class="criteria-title-content">
                        <span class="criteria-main-title">{{
                          item.CriteriaTitle
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="question-answer-section">
                    <div class="question-card mb-2">
                      <div class="question-header">
                        <span class="question-label">Question</span>
                      </div>
                      <div class="question-text">{{ item.QuestionsText }}</div>
                    </div>
                    <div class="answer-card">
                      <div class="answer-header">
                        <span class="answer-label">Answer</span>
                      </div>

                      <div class="answer-content">
                        <p class="answer-text" v-html="item.AnswerText"></p>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" v-if="item.EventDetails.length > 0">
                  <div class="attachments-section">
                    <div class="attachments-header">
                      <span class="attachments-title-wrapper">
                        <v-icon color="#7c4dff" class="mr-2"
                          >mdi-paperclip</v-icon
                        >
                        <span class="attachments-title">Attachments</span>
                      </span>
                    </div>
                    <div class="attachments-grid">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          lg="3"
                          v-for="(row, index) in item.EventDetails"
                          :key="index"
                        >
                          <div class="attachment-card">
                            <div class="attachment-card-header">
                              <viewer rebuild :images="row.EventImagesArray">
                                <img
                                  style="width: 80px; height: 80px"
                                  :src="src"
                                  :key="src"
                                  v-for="src in row.EventImagesArray"
                                />
                              </viewer>
                            </div>
                            <div class="attachment-content">
                              <div>
                                <strong>Event Date:</strong>
                                <span>{{ row.EventDate }}</span>
                              </div>
                              <div>
                                <strong>Event Name:</strong>
                                <span>{{ row.EventName }}</span>
                              </div>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <!-- Award Attachments -->
          <div
            v-if="row.AnswerAttachmentOfficers.length > 0"
            class="award-section-card mt-4"
          >
            <div class="section-header">
              <span class="section-title-wrapper">
                <v-icon color="#7c4dff" class="mr-2">mdi-paperclip</v-icon>
                <span class="section-title">Award Attachments</span>
              </span>
            </div>
            <div class="section-content">
              <v-row wrap>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  v-for="(data, k) in row.AnswerAttachmentOfficers"
                  :key="k"
                >
                  <div class="attachment-card">
                    <div class="attachment-card-header">
                      <viewer rebuild :images="data.EventImagesArray">
                        <img
                          style="padding: 5px"
                          width="80"
                          height="80"
                          :src="src"
                          :key="src"
                          v-for="src in data.EventImagesArray"
                        />
                      </viewer>
                    </div>
                    <div class="attachment-content">
                      <div>
                        <strong>Event Date:</strong>
                        <span>{{ data.EventDate }}</span>
                      </div>
                      <div>
                        <strong>Event Name:</strong>
                        <span>{{ data.EventName }}</span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <!-- Video Section -->
          <div
            v-if="row.AwardVideoPath != null"
            class="award-section-card mt-4"
          >
            <div class="section-header">
              <span class="section-title-wrapper">
                <v-icon color="#1976d2" class="mr-2">mdi-video</v-icon>
                <span class="section-title">Video Details</span>
              </span>
            </div>
            <div class="section-content">
              <v-row wrap>
                <v-col cols="12" sm="12" lg="4">
                  <video
                    :src="row.AwardVideoPath"
                    width="100%"
                    controls
                    class="mt-4"
                  ></video>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-container>
      </v-card-text>
      <!-- Professional Footer Actions -->
      <v-card-actions class="professional-footer-actions">
        <div class="footer-content-centered">
          <v-btn
            @click="closePrompt"
            color="#1976d2"
            class="professional-close-btn"
          >
            <v-icon left>mdi-close</v-icon>
            Close
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  props: {
    previewRecordPrompt: {
      required: true,
      Type: Boolean,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      LoadingFlag: false,
      SubmitFlag: false,
      OverlayLoadingFlag: false,
      search: "",

      ProgessStart: 0,
      uploadPercentage: 0,

      valid: true,

      row: {},
      AwardId: 0,

      RoleId: 0,
      PageInfo: {},
      PageTitle: "Award Preview",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      awardHeaders: [
        { text: "Criteria", value: "Criteria" },
        { text: "Max Points", value: "MaxPoints", align: "center" },
        { text: "Received Points", value: "ReceivedPoints", align: "center" },
        { text: "Points", value: "PointsColor", align: "center" },
        { text: "Note", value: "Note", align: "center" },
      ],
    };
  },
  watch: {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");

      console.log("recordData = " + JSON.stringify(this.recordData));
      this.AwardId = this.recordData.AwardId;

      this.getTableRecords();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var AwardId = this.AwardId;
      console.log({ AwardId });

      if (AwardId > 0) {
        this.DownloadFlag = false;
        this.ExcelFileName = "";
        this.ZipDownloadFlag = false;
        this.ZipFileName = "";
        this.tableData1 = [];
        this.selected1 = [];

        this.LoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award/show";
        var upload = {
          UserInterface: 2,
          Award: this.AwardId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log({ server_url }, { token }, { add_url });

        const thisIns = this;
        var output = "";
        var records = [];
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log({ output }, { flag });

            console.log({ records });

            thisIns.row = records;
          })
          .catch(function (error) {
            console.log({ error });
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Kindy fill required fields and then submit";
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#lom-award-preview {
  .professional-preview-dialog {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .main-preview-container {
    border-radius: 16px !important;
    overflow: hidden;
    max-width: 100%;
    background: #ffffff;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12) !important;
  }
  .full-width-card {
    width: 100%;
    max-width: 100vw !important;
    margin: 0 !important;
    border-radius: 24px !important;
    box-shadow: 0 8px 32px rgba(124, 77, 255, 0.12);
    background: linear-gradient(90deg, #ede7f6 0%, #f3e5f5 100%);
    transition: box-shadow 0.3s, transform 0.3s;
    animation: fadeIn 0.7s;
    &:hover {
      box-shadow: 0 12px 40px rgba(124, 77, 255, 0.18);
      transform: translateY(-2px) scale(1.01);
    }
    .score-title {
      font-size: 1.35rem;
      color: #7c4dff;
      font-weight: 700;
      letter-spacing: 0.02em;
      animation: fadeIn 0.7s;
    }
  }

  @media (max-width: 1024px) {
    .full-width-card {
      border-radius: 18px !important;
      padding: 1.5rem !important;
    }
  }
  @media (max-width: 768px) {
    .full-width-card {
      border-radius: 14px !important;
      padding: 1rem !important;
    }
    .score-title {
      font-size: 1.1rem;
    }
  }
  @media (max-width: 480px) {
    .full-width-card {
      border-radius: 8px !important;
      padding: 0.5rem !important;
    }
    .score-title {
      font-size: 0.95rem;
    }
  }
  .score-details-section {
    .section-header {
      background: linear-gradient(135deg, #ede7f6 0%, #e3f2fd 100%);
      border-bottom: 1px solid rgba(124, 77, 255, 0.12);
      .section-title {
        color: #7c4dff;
        font-size: 1.3rem;
        font-weight: 700;
        letter-spacing: 0.01em;
      }
    }
    .section-content {
      padding: 2rem 1rem;
    }
  }

  .score-card {
    background: linear-gradient(135deg, #f3e5f5 0%, #ede7f6 100%);
    border: 1px solid #d1c4e9;
    box-shadow: 0 4px 18px rgba(124, 77, 255, 0.1);
    border-radius: 20px;
    transition: box-shadow 0.3s, transform 0.3s;
    &:hover {
      box-shadow: 0 8px 32px rgba(124, 77, 255, 0.18);
      transform: translateY(-2px);
    }
    .score-title {
      color: #7c4dff;
      font-size: 1.2rem;
      letter-spacing: 0.02em;
      font-weight: 700;
      animation: fadeIn 0.7s;
    }
  }

  .award-jci-table.responsive-table {
    width: 100%;
    th,
    td {
      padding: 0.7rem 0.4rem;
      font-size: 1rem;
      text-align: center;
      vertical-align: middle;
    }
    th {
      background: #ede7f6;
      color: #7c4dff;
      font-weight: 600;
      border-bottom: 2px solid #d1c4e9;
    }
    td {
      background: #fff;
      border-bottom: 1px solid #f3e5f5;
      transition: background 0.3s;
    }
    .criteria-cell {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      .criteria-text {
        font-weight: 500;
        font-size: 1rem;
        color: #512da8;
      }
    }
    .max-points-cell {
      color: #512da8;
      font-weight: 500;
    }
    .score-chip {
      box-shadow: 0 2px 8px rgba(124, 77, 255, 0.1);
      transition: transform 0.3s, box-shadow 0.3s;
      cursor: pointer;
      border-radius: 8px !important;
      font-size: 1rem !important;
      font-weight: 600 !important;
      &:hover {
        box-shadow: 0 4px 16px rgba(124, 77, 255, 0.18);
        transform: scale(1.12);
      }
    }
    .score-row {
      animation: fadeInUp 0.6s;
      transition: background 0.3s;
      &:hover {
        background: #f3e5f5;
      }
    }
    .score-total-row {
      background: #ede7f6;
      font-size: 1.1rem;
      animation: fadeInUp 0.8s;
      font-weight: 700;
    }
  }

  .animate-icon {
    animation: iconPop 0.7s;
  }
  .animate-title {
    animation: fadeIn 0.7s;
  }
  .animate-chip {
    animation: chipFade 0.7s;
  }

  .animate-fade-in {
    animation: fadeIn 0.7s;
  }
  .animate-slide-up {
    animation: slideUp 0.7s;
  }
  .animate-row-fade {
    animation: fadeInUp 0.6s;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes iconPop {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }
    60% {
      transform: scale(1.2);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  @keyframes chipFade {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  .number-fade-enter-active,
  .number-fade-leave-active {
    transition: opacity 0.5s;
  }
  .number-fade-enter,
  .number-fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  @media (max-width: 768px) {
    .score-card {
      max-width: 98vw !important;
      padding: 1rem !important;
      border-radius: 14px !important;
    }
    .award-jci-table.responsive-table th,
    .award-jci-table.responsive-table td {
      font-size: 0.95rem;
      padding: 0.5rem 0.2rem;
    }
    .score-title {
      font-size: 1rem;
    }
  }
  @media (max-width: 480px) {
    .score-card {
      max-width: 100vw !important;
      padding: 0.5rem !important;
      border-radius: 10px !important;
    }
    .award-jci-table.responsive-table th,
    .award-jci-table.responsive-table td {
      font-size: 0.85rem;
      padding: 0.3rem 0.1rem;
    }
    .score-title {
      font-size: 0.95rem;
    }
  }

  .score-details-section {
    .section-header {
      background: linear-gradient(135deg, #ede7f6 0%, #e3f2fd 100%);
      border-bottom: 1px solid rgba(124, 77, 255, 0.12);
      .section-title {
        color: #7c4dff;
      }
    }
    .section-content {
      padding: 2rem 1rem;
    }
  }

  .score-card {
    background: linear-gradient(135deg, #f3e5f5 0%, #ede7f6 100%);
    border: 1px solid #d1c4e9;
    box-shadow: 0 4px 18px rgba(124, 77, 255, 0.08);
    border-radius: 16px;
    transition: box-shadow 0.3s, transform 0.3s;
    &:hover {
      box-shadow: 0 8px 32px rgba(124, 77, 255, 0.15);
      transform: translateY(-2px);
    }
    .score-title {
      color: #7c4dff;
      font-size: 1.25rem;
      letter-spacing: 0.02em;
    }
  }

  .award-jci-table {
    th {
      background: #ede7f6;
      color: #7c4dff;
      font-weight: 600;
      font-size: 1rem;
      border-bottom: 2px solid #d1c4e9;
      text-align: center;
      padding: 0.75rem;
    }
    td {
      background: #fff;
      font-size: 1rem;
      padding: 0.75rem;
      border-bottom: 1px solid #f3e5f5;
      transition: background 0.3s;
    }
    .criteria-cell {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    .max-points-cell {
      text-align: center;
      color: #512da8;
      font-weight: 500;
    }
    .score-chip {
      box-shadow: 0 2px 8px rgba(124, 77, 255, 0.15);
      transition: transform 0.3s;
      cursor: pointer;
    }
    .score-row {
      animation: fadeInUp 0.6s;
    }
    .score-total-row {
      background: #ede7f6;
      font-size: 1.1rem;
      animation: fadeInUp 0.8s;
    }
  }

  .animate-fade-in {
    animation: fadeIn 0.7s;
  }
  .animate-slide-up {
    animation: slideUp 0.7s;
  }
  .animate-row-fade {
    animation: fadeInUp 0.6s;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .number-fade-enter-active,
  .number-fade-leave-active {
    transition: opacity 0.5s;
  }
  .number-fade-enter,
  .number-fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  // Professional Header
  .professional-preview-header {
    .header-gradient {
      background: linear-gradient(
        135deg,
        #1976d2 0%,
        #1565c0 50%,
        #0d47a1 100%
      );
      position: relative;
      overflow: hidden;
    }
  }

  .professional-app-bar {
    position: relative;
    min-height: 80px;
    display: flex;
    align-items: center;
    overflow: hidden;
    .app-bar-background {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        135deg,
        #1565c0 0%,
        #1976d2 25%,
        #1e88e5 50%,
        #2196f3 75%,
        #42a5f5 100%
      );
      .background-pattern {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: radial-gradient(
          circle at 50% 10%,
          rgba(255, 255, 255, 0.05) 1.5px,
          transparent 1.5px
        );
        background-size: 60px 60px, 40px 40px, 80px 80px;
        animation: patternFloat 20s ease-in-out infinite;
      }
      .background-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }
    .app-bar-content {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 1.25rem 2rem;
      .left-section {
        display: flex;
        align-items: center;
        flex: 1;
        .title-content {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1976d2;
          letter-spacing: 0.02em;
        }
        .main-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1976d2;
        }
      }
      .right-section {
        .professional-close-btn {
          background: linear-gradient(
            135deg,
            #1976d2 0%,
            #1565c0 100%
          ) !important;
          color: white !important;
          font-weight: 600 !important;
          text-transform: none !important;
          border-radius: 12px !important;
          padding: 0 2rem !important;
          height: 48px !important;
          font-size: 1rem !important;
          box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3) !important;
          transition: all 0.3s ease !important;
          border: none !important;
        }
      }
    }
  }

  @keyframes patternFloat {
    0%,
    100% {
      transform: translateY(0) rotate(0deg);
    }
    50% {
      transform: translateY(-10px) rotate(180deg);
    }
  }

  .professional-loading-section {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    background: linear-gradient(45deg, #f5f7fa 0%, #c3cfe2 100%);
    .loading-container {
      text-align: center;
      .loading-text {
        font-size: 1.1rem;
        color: #1976d2;
        font-weight: 500;
        margin: 0;
      }
    }
  }

  .main-content-wrapper {
    background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
    padding: 2rem !important;
  }

  .award-section-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(25, 118, 210, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    &:hover {
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }
    .section-header {
      background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
      padding: 1.5rem 2rem;
      border-bottom: 1px solid rgba(25, 118, 210, 0.1);
      .section-title-wrapper {
        display: flex;
        align-items: center;
        .section-title {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1976d2;
        }
      }
    }
    .section-content {
      padding: 2rem;
    }
  }

  .detail-item {
    .detail-label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;
    }
    .detail-value {
      font-size: 1rem;
      color: #2c3e50;
      font-weight: 500;
      margin: 0;
      padding: 0.75rem 1rem;
      background: #f8f9fa;
      border-radius: 8px;
      border-left: 4px solid #1976d2;
    }
  }

  .status-chip-wrapper {
    .status-chip {
      font-weight: 600 !important;
      font-size: 0.875rem !important;
      padding: 0 16px !important;
      height: 36px !important;
      color: white !important;
    }
  }

  .member-photo-section {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    .photo-container {
      position: relative;
      display: inline-block;
      .member-avatar {
        border: 4px solid #e3f2fd;
        transition: all 0.3s ease;
      }
    }
  }

  .criteria-item-wrapper {
    margin-bottom: 2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .criteria-title-section {
    margin-bottom: 1.5rem;
    .criteria-title-card {
      background: linear-gradient(135deg, #e8f5e8 0%, #f1f8e9 100%);
      border: 1px solid #4caf50;
      border-radius: 12px;
      padding: 1.5rem;
      .criteria-title-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 1rem;
        .criteria-main-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: #388e3c;
        }
      }
    }
  }

  .question-answer-section {
    .question-card,
    .answer-card {
      background: white;
      border-radius: 12px;
      padding: 1.25rem;
      border: 1px solid #e0e0e0;
      .question-header,
      .answer-header {
        display: flex;
        align-items: center;
        margin-bottom: 0.75rem;
        .question-label,
        .answer-label {
          font-size: 1rem;
          font-weight: 600;
        }
      }
      .question-text,
      .answer-text {
        font-size: 1rem;
        line-height: 1.6;
        color: #424242;
        margin: 0;
      }
    }
    .question-card {
      border-left: 4px solid #ff9800;
      background: #fff3e0;
      .question-label {
        color: #f57c00;
      }
    }
    .answer-card {
      border-left: 4px solid #2196f3;
      background: #e3f2fd;
      .answer-label {
        color: #1976d2;
      }
      .answer-content {
        background: white;
        padding: 1rem;
        border-radius: 8px;
        border: 1px solid #e1f5fe;
      }
    }
  }

  .attachments-section {
    margin-top: 2rem;
    .attachments-header {
      margin-bottom: 1.5rem;
      .attachments-title-wrapper {
        display: flex;
        align-items: center;
        .attachments-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: #7c4dff;
        }
      }
    }
    .attachments-grid {
      .attachment-card {
        border-radius: 12px !important;
        overflow: hidden;
        transition: all 0.3s ease;
        border: 1px solid #e1bee7;
        .attachment-card-header {
          text-align: center;
          margin-bottom: 0.5rem;
        }
        .attachment-content {
          font-size: 0.95rem;
          color: #2c3e50;
        }
      }
    }
  }

  .professional-footer-actions {
    background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
    border-top: 1px solid rgba(25, 118, 210, 0.1);
    padding: 2rem !important;
    .footer-content-centered {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      .professional-close-btn {
        background: linear-gradient(
          135deg,
          #1976d2 0%,
          #1565c0 100%
        ) !important;
        color: white !important;
        font-weight: 600 !important;
        text-transform: none !important;
        border-radius: 12px !important;
        padding: 0 2rem !important;
        height: 48px !important;
        font-size: 1rem !important;
        box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3) !important;
        transition: all 0.3s ease !important;
        border: none !important;
      }
    }
  }

  @media (max-width: 1024px) {
    .professional-app-bar {
      .app-bar-content {
        padding: 1rem 1.5rem;
      }
    }
    .main-preview-container {
      margin: 0.5rem;
      border-radius: 12px !important;
    }
    .main-content-wrapper {
      padding: 1.5rem !important;
    }
  }
  @media (max-width: 768px) {
    .professional-app-bar {
      min-height: 70px;
      .app-bar-content {
        padding: 0.75rem 1rem;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
      }
    }
    .main-content-wrapper {
      padding: 1rem !important;
    }
    .award-section-card {
      .section-content {
        padding: 1rem;
      }
    }
    .footer-content-centered {
      .professional-close-btn {
        width: 100%;
        max-width: 280px;
      }
    }
  }
  @media (max-width: 480px) {
    .professional-app-bar {
      min-height: 60px;
      .app-bar-content {
        padding: 0.5rem 0.75rem;
      }
    }
    .main-preview-container {
      margin: 0.25rem;
      border-radius: 8px !important;
    }
  }
}
</style>
